var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkCircle2 = function SvgCheckmarkCircle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.495 9.144h.002c.46 0 .833.372.834.831a8.277 8.277 0 0 1-2.424 5.9 8.28 8.28 0 0 1-5.885 2.458h-.025a8.277 8.277 0 0 1-5.875-2.424 8.279 8.279 0 0 1-2.458-5.886 8.275 8.275 0 0 1 2.424-5.9 8.279 8.279 0 0 1 5.885-2.457c.663.01 1.338.077 1.984.232a.834.834 0 0 1-.39 1.62 7.348 7.348 0 0 0-1.589-.185A6.622 6.622 0 0 0 5.27 5.299a6.623 6.623 0 0 0-1.94 4.72 6.623 6.623 0 0 0 1.967 4.708 6.624 6.624 0 0 0 4.7 1.939h.02a6.622 6.622 0 0 0 4.708-1.966 6.624 6.624 0 0 0 1.94-4.72c-.002-.46.37-.835.83-.836ZM6.908 9.41a.832.832 0 0 1 1.179 0l1.87 1.87 5.247-5.997a.833.833 0 0 1 1.253 1.098l-5.833 6.667a.835.835 0 0 1-.6.285h-.027a.832.832 0 0 1-.589-.245l-2.5-2.5a.832.832 0 0 1 0-1.178Z",
    fill: "#008545"
  })));
};
export default SvgCheckmarkCircle2;